import ReactDOM from 'react-dom/client';
import './i18n/bootstrap';
import 'globalthis/polyfill';
import 'globalthis/auto';
import 'babel-polyfill';
import './utils/polyfill-queue-microtask';
import './assets/styles/swiper.min.css';
import './assets/styles/theme/theme.css';
import './assets/styles/font.css';
import './assets/styles/global.css';
import './index.css';
import './utils/sentry';
// 尽早挂载 html.mobile-h5，供 CSS Modules 全局覆盖
import '@/utils/vip';
import App from './app';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
